module.exports = __webpack_public_path__ + "img/plan_custom.c552842c.svg";